import * as React from 'react';
import { useState } from 'react';
import { TextField, Button, Container, Typography, Box, Alert } from '@mui/material';
import Dashboard from './Dashboard';

const USERNAME = "admin";
const PASSWORD = "password123";

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    if (username === USERNAME && password === PASSWORD) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid username or password. Please try again.');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  if (isAuthenticated) {
    return <Dashboard />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h4" sx={{ fontWeight: 'bold', color: '#3c7f72', mb: 2 }}>
          JobSight Login
        </Typography>
        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        <TextField
          margin="normal"
          required
          fullWidth
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, bgcolor: '#3c7f72' }}
          onClick={handleLogin}
        >
          Log In
        </Button>
      </Box>
    </Container>
  );
}
